import styled from 'styled-components';

import { Link } from '@savgroup-front-common/core/atoms/link';
import { fontStyle } from '@savgroup-front-common/core/theme/helpers/fontStyle';
import { spacing } from '@savgroup-front-common/primitive/helpers/spacing';

export const $ToastLink = styled(Link)`
  display: block;
  text-decoration: underline;
  font-weight: 700;
  margin-top: ${spacing('xxs')};
`;

export const $ToastTime = styled.p`
  color: ${({ theme }) => theme.colors.paragraphTextColor};
  ${fontStyle('xs')};
  font-weight: 700;
  margin: 0;

  display: flex;
  justify-content: space-between;
`;
